import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar"; 
import Hero from "./components/Hero";// Corrected path
import CompactHomepage from "./components/CompactHomepage";
import Appreciations from "./components/Appreciations";
import Contact from "./components/Contact";
import LowerHomepage from "./components/LowerHomepage";
import { languageOptions, translations } from "./translations.clean";
import "./App.css";

const App = () => {
  const [language, setLanguage] = useState(() => {
    const urlLanguage = new URLSearchParams(window.location.search).get("lang");
    const savedLanguage = localStorage.getItem("pams-language");
    return languageOptions.some((option) => option.code === urlLanguage)
      ? urlLanguage
      : savedLanguage || "en";
  });
  const selectedLanguage = languageOptions.find((option) => option.code === language) || languageOptions[0];
  const t = translations[selectedLanguage.code] || translations.en;

  useEffect(() => {
    localStorage.setItem("pams-language", selectedLanguage.code);
    document.documentElement.lang = selectedLanguage.code;
    document.documentElement.dir = selectedLanguage.dir;
  }, [selectedLanguage.code, selectedLanguage.dir]);

  return (
    <div className={`site-shell ${selectedLanguage.dir === "rtl" ? "rtl" : "ltr"}`} dir={selectedLanguage.dir}>
      <Navbar
        t={t.nav}
        language={selectedLanguage.code}
        languages={languageOptions}
        onLanguageChange={setLanguage}
      />
      <main>
        <Hero t={t.hero} />
        <CompactHomepage t={t.compact} />
        <Appreciations t={t.appreciations} />
        <Contact t={t.contact} />
        <LowerHomepage t={t.lower} />
      </main>
    </div>
  );
};

export default App;
